/**
 * Payments module configuration
 * ──────────────────────────────────────
 * Change VOUCHER_LABEL to rename "Voucher" everywhere in this module.
 */
import { ENTITIES } from '../../constants/labels';
import { DOCUMENT_STATUS } from '../../constants/statusMaps';

// ── Change this to rename "Voucher" everywhere in this module ─────────────
export const EXPENSES_LABEL = ENTITIES.voucher;

export { DOCUMENT_STATUS as STATUS_CONFIG };
